export default __webpack_public_path__ + "static/media/question.fd1bd0eb.svg";